var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackspace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3953 30.4797C11.6063 30.7215 11.8667 30.9153 12.1588 31.0482C12.4509 31.1811 12.7681 31.2499 13.0891 31.25H32.3281C32.9255 31.2473 33.4976 31.0088 33.92 30.5864C34.3424 30.164 34.5809 29.5919 34.5836 28.9945V11.0055C34.5809 10.4081 34.3424 9.83597 33.92 9.41356C33.4976 8.99116 32.9255 8.75267 32.3281 8.75H13.0891C12.7684 8.7503 12.4515 8.81903 12.1596 8.9516C11.8676 9.08417 11.6073 9.27753 11.3961 9.51875L4.45312 20L11.3953 30.4773V30.4797Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1365 15.0258L16.9795 25.1828",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1365 25.1828L16.9795 15.0258",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1365 15.0258L16.9795 25.1828",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1365 25.1828L16.9795 15.0258",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackspace);
export default __webpack_public_path__ + "static/media/backspace.b1820fec89c9753141ed491ebb63e08f.svg";
export { ForwardRef as ReactComponent };